import * as S from './TermFullSheet.styled';
import FullSheet from '../FullSheet/FullSheet';
import { HeadTitle } from 'oui';
import React from 'react';

export interface ITermFullSheetProps {
  isOpen: boolean;
  path?: string;
  title: string;
  onClickClose: () => void;
}

const TermFullSheet = ({
  isOpen,
  title,
  path,
  onClickClose,
}: ITermFullSheetProps) => {
  return (
    <>
      <FullSheet isOpen={isOpen}>
        <HeadTitle
          textTitle={title ?? ''}
          buttonIconName={'CloseSharp'}
          onClickButton={onClickClose}
        />
        <S.IFrameWrap>{path && <S.Iframe src={path} />}</S.IFrameWrap>
      </FullSheet>
    </>
  );
};

export default TermFullSheet;
